<template>
  <span
    class="tooltip"
    @click="onClick"
    @mouseover="onMouseover"
    @mouseout="onMouseout"
  >
    <span :class="_tooltipTextWrapperClass" :style="tooltipTextWrapperStyle">
      <span :class="tooltipTextClass" :style="tooltipTextStyle">
        {{ tooltipText }}
      </span>
    </span>
    <slot></slot>
  </span>
</template>

<script>
export default {
  name: "PlaybackControllerTooltip",
  props: {
    tooltipText: {
      type: String,
      default: "",
    },
    tooltipTextWrapperClass: {
      type: String,
      default: "tooltip-text-wrapper",
    },
    tooltipTextClass: {
      type: String,
      default: "tooltip-text aisea-text-12-400-pure-white",
    },
    tooltipTextWrapperStyle: {
      type: Object, // {[key: string]: boolean}
      default: () => ({}),
    },
    tooltipTextStyle: {
      type: Object, // {[key: string]: boolean}
      default: () => ({}),
    },
  },
  data() {
    return {
      isClicked: false,
    };
  },
  computed: {
    _tooltipTextWrapperClass() {
      if (!this.isClicked) return this.tooltipTextWrapperClass;
      return `${this.tooltipTextWrapperClass} clicked`;
    },
  },
  methods: {
    onMouseover() {
      this.isClicked = false;
      this.$emit("mouseover");
    },
    onMouseout() {
      this.isClicked = false;
      this.$emit("mouseout");
    },
    onClick() {
      this.isClicked = true;
      this.$emit("click");
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
.tooltip {
  z-index: 2;
  position: relative;
  cursor: pointer;
  @mixin hover-style() {
    display: flex;
    justify-content: center;
    align-items: center;
    width: max-content;

    left: 50%;
    bottom: 100%;
    transform: translate(-50%, -5px);
    opacity: 1;
  }
  .tooltip-text-wrapper {
    display: none;
    position: absolute;
    background: $aisea-black;
    border-radius: 5px;
    line-height: 1;
    padding: 9px;
    text-align: center;
    margin-top: -60%;
    opacity: 0;
    transition: opacity 0.5s ease 0s;
  }
  &:hover .tooltip-text-wrapper:not(.clicked) {
    @include hover-style();
  }
}
</style>
